<template>
  <el-card
class="card-container"
shadow="never">
    <el-row
slot="header"
type="flex"
justify="space-between"
align="middle">
      <h1 class="card-container__title">Modules hiển thị ({{ data.length }})</h1>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="handleCreate"
      >
        Thêm mới
      </el-button>
    </el-row>
    <el-table
header-row-class-name="table-header"
:data="data"
size="small">
      <el-table-column
        v-for="(c, index) in columns"
        :key="index"
        :prop="c.key"
        :label="c.label"
        :align="c.align"
        :width="c.width"
        :min-width="c.min_width"
      >
        <template slot-scope="scope">
          <span v-if="c.key === 'roles'">
            <el-tag
              v-for="role in showListRoles(scope.row[c.key], roles)"
              :key="role.id"
              class="mr-xs mb-xs"
              size="mini"
            >
              {{ role.name }}
            </el-tag>
          </span>
          <span v-else-if="c.key === 'create_fields'">
            <el-tag
              v-for="field in showListCreateFields(scope.row[c.key])"
              :key="field.key"
              class="mr-xs mb-xs"
              size="mini"
            >
              {{ field.name }}
            </el-tag>
          </span>
          <span v-else-if="c.key === 'groups'">
            <el-tag
              v-for="group in showListGroups(scope.row[c.key])"
              :key="group.id"
              class="mr-xs mb-xs"
              size="mini"
            >
              {{ group.name }}
            </el-tag>
          </span>
          <span v-else-if="c.key === 'contracts'">
            <el-tag
              v-for="contract in showListContracts(scope.row[c.key])"
              :key="contract.id"
              class="mr-xs mb-xs"
              size="mini"
            >
              {{ contract.name }}
            </el-tag>
          </span>
          <span v-else>
            {{ scope.row[c.key] }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="Thao tác"
        width="100"
        fixed="right"
        align="center"
      >
        <template slot-scope="scope">
          <Buttons
            :item="scope.row"
            :buttons="['edit', 'delete']"
            @edit="(v) => handleUpdate(v)"
            @delete="(v) => handleDelete(v)"
          />
        </template>
      </el-table-column>
    </el-table>
    <ModuleFormPopup
      v-if="formVisible"
      :visible="formVisible"
      :item="selectedItem"
      :modules="data"
      :groups="groups"
      :roles="roles"
      :fields="fields"
      :contracts="contracts"
      @close="formVisible = false"
      @save="handleSave"
    />
  </el-card>
</template>

<script>
import ModuleFormPopup from "../../popups/ModuleForm.vue";
import Buttons from "@/components/items/Buttons.vue";
import roleServices from "@/services/role";
import contractServices from "@/services/contract";
import { notification } from "@/utils/common";

export default {
  name: "ConfigObjectModules",
  components: {
    ModuleFormPopup,
    Buttons,
  },
  props: {
    object: Object,
  },
  data() {
    return {
      selectedItem: null,
      formVisible: false,
      roles: [],
      contracts: []
    };
  },
  computed: {
    data() {
      return (this.object?.extra?.modules || []).sort(
        (a, b) => a.order - b.order
      );
    },
    groups() {
      const data = this.object?.extra?.groups || [];
      return data;
    },
    fields() {
      const data = this.object?.extra?.fields || [];
      return data;
    },
    columns() {
      return [
        {
          label: "STT",
          key: "order",
          width: 50,
        },
        {
          label: "Mã module",
          key: "key",
          width: 200,
        },
        {
          label: "Tên module",
          key: "name",
          width: 250,
        },
        {
          label: "Quyền hạn",
          key: "roles",
          width: 300,
        },
        {
          label: "Trường tạo mới",
          key: "create_fields",
          width: 300,
        },
        {
          label: "Nhóm hiển thị",
          key: "groups",
          width: 300,
        },
        {
          label: "Luồng áp dụng",
          key: "contracts",
          width: 300,
        }
      ];
    },
    roleParams() {
      const _params = {
        offset: 0,
        limit: 999,
        locale: "vi",
        sort: "-created",
        filters: {
          organization_id: this.object.extra?.organization_id
        }
      };
      return _params;
    },
    contractParams() {
      const _params = {
        offset: 0,
        limit: 999,
        locale: "vi",
        sort: "-created",
        filters: {
          organization_id: this.object.extra?.organization_id
        }
      };
      return _params;
    },
  },
  beforeMount() {
    this.fetchAllRoles();
    this.fetchAllContracts();
  },
  methods: {
    fetchAllRoles() {
      roleServices
      .list(this.roleParams)
        .then((response) => {
          this.roles = response.items.map((c) => ({
            id: c.id,
            name: c.translations?.vi?.name
          }))
        })
        .catch(() => {
          this.roles = [];
        });
    },
    fetchAllContracts() {
      contractServices
      .list(this.contractParams)
        .then((response) => {
          this.contracts = response.items.map((c) => ({
            id: c.id,
            name: c.translations?.vi?.name
          }))
        })
        .catch(() => {
          this.contracts = [];
        });
    },
    handleCreate() {
      this.selectedItem = null;
      this.formVisible = true;
    },
    handleUpdate(item) {
      this.selectedItem = item;
      this.formVisible = true;
    },
    handleDelete(item) {
      this.$confirm(`Bạn có chắc chắn muốn xoá không?`, "Xác nhận", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      }).then(() => {
        const modules = this.data.filter((g) => g.key !== item.key);
        this.handleSave({
          payload: { modules },
          success: () => {
            notification(this, "success", "delete", `nhóm hiển thị`);
          },
          error: () => {
            notification(this, "error", "delete", "nhóm hiển thị");
          },
        });
      });
    },
    handleSave(data = { payload: {}, success: () => {}, error: () => {} }) {
      this.$emit("save", {
        payload: data.payload,
        success: data.success,
        error: data.error,
      });
    },
    showListRoles(ids = [], roles = []) {
      return roles.filter((r) => ids.includes(r.id))
    },
    showListCreateFields(keys = []) {
      return this.fields.filter((g) => keys.includes(g.key))
    },
    showListGroups(keys = []) {
      return this.groups.filter((g) => keys.includes(g.key))
    },
    showListContracts(keys = []) {
      return this.contracts.filter((g) => keys.includes(g.id))
    },
  },
};
</script>

<style lang="scss" scoped></style>
